(function () {
  'use strict';

  if (window.everlastSearchSuggestions) return;
  window.everlastSearchSuggestions = true;

  var controllers = new Map();
  var cache = new Map();
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function normalize(text) {
    return String(text || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }

  function titleScore(article, query) {
    var title = normalize(article.title);
    var terms = normalize(query).split(' ').filter(Boolean);
    if (!terms.length) return 0;
    var words = title.split(' ');
    if ((' ' + title + ' ').includes(' ' + terms.join(' ') + ' ')) return 3;
    if (terms.every(function (term) { return words.some(function (word) { return word.startsWith(term); }); })) return 2;
    return terms.some(function (term) { return words.some(function (word) { return word.startsWith(term); }); }) ? 1 : 0;
  }

  function searchUrl(query, type) {
    var params = new URLSearchParams({ q: query, 'options[prefix]': 'last' });
    if (type) params.set('type', type);
    return root + 'search?' + params.toString();
  }

  function safeUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && /^https?:$/.test(url.protocol) ? url.href : null;
    } catch (error) {
      return null;
    }
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-search-suggestions]').forEach(function (form) {
      if (controllers.has(form)) return;
      var input = form.querySelector('[name="q"]');
      var panel = form.querySelector('.everlast-search-suggestions');
      var status = form.querySelector('[data-search-status]');
      if (!input || !panel || !status) return;

      var timer;
      var request;
      var generation = 0;
      var selected = -1;
      var composing = false;

      function resetSelection() {
        selected = -1;
        input.removeAttribute('aria-activedescendant');
        panel.querySelectorAll('[aria-selected="true"]').forEach(function (option) {
          option.setAttribute('aria-selected', 'false');
        });
      }

      function close() {
        clearTimeout(timer);
        generation += 1;
        if (request) request.abort();
        panel.hidden = true;
        panel.removeAttribute('aria-busy');
        input.setAttribute('aria-expanded', 'false');
        status.textContent = '';
        resetSelection();
      }

      function show() {
        if (document.activeElement !== input) return;
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function option(container, title, url, meta, image) {
        var href = safeUrl(url);
        if (!href) return;
        var link = document.createElement('a');
        link.href = href;
        link.className = 'everlast-search-option';
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.tabIndex = -1;
        link.id = panel.id + '-option-' + panel.querySelectorAll('[role="option"]').length;
        if (image) {
          try {
            var imageUrl = new URL(image, window.location.origin);
            if (/^https?:$/.test(imageUrl.protocol)) {
              var thumbnail = document.createElement('img');
              thumbnail.src = imageUrl.href;
              thumbnail.alt = '';
              thumbnail.width = 48;
              thumbnail.height = 48;
              thumbnail.loading = 'lazy';
              thumbnail.className = 'everlast-search-image';
              link.appendChild(thumbnail);
            }
          } catch (error) { /* A missing image should not hide a result. */ }
        }
        var copy = document.createElement('span');
        copy.className = 'everlast-search-option-copy';
        var label = document.createElement('span');
        label.className = 'everlast-search-option-title';
        label.textContent = title;
        copy.appendChild(label);
        if (meta) {
          var detail = document.createElement('span');
          detail.className = 'everlast-search-option-meta';
          detail.textContent = meta;
          copy.appendChild(detail);
        }
        link.appendChild(copy);
        container.appendChild(link);
        return link;
      }

      function productMeta(product) {
        var price = Number(product.price_min || product.price);
        if ((product.tags || []).includes('quote') || price === 0) return 'Request a quote';
        if (!product.available) return 'Sold out';
        if (!Number.isFinite(price)) return '';
        var amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: form.dataset.currency || 'USD'
        }).format(price);
        return Number(product.price_max) > price ? 'From ' + amount : amount;
      }

      function render(results, query, failed) {
        panel.replaceChildren();
        panel.removeAttribute('aria-busy');
        resetSelection();
        var articles = (results.articles || []).slice().sort(function (a, b) {
          return titleScore(b, query) - titleScore(a, query)
            || (Date.parse(b.published_at) || 0) - (Date.parse(a.published_at) || 0);
        });
        var pages = (results.pages || []).filter(function (page) {
          return !(page.handle || '').includes('traverse-wall-route-maps');
        });
        var groups = [
          { label: 'Products', type: 'product', items: (results.products || []).slice(0, 4) },
          { label: 'Blog posts', type: 'article', items: articles.slice(0, 4) },
          { label: 'Resources', type: 'page', items: pages.slice(0, 2) }
        ];
        groups.sort(function (a, b) {
          function bestTitleScore(group) {
            return Math.max(0, ...group.items.map(function (item) { return titleScore(item, query); }));
          }
          return bestTitleScore(b) - bestTitleScore(a);
        });
        var count = 0;
        groups.forEach(function (group) {
          if (!group.items.length) return;
          var container = document.createElement('div');
          container.className = 'everlast-search-group';
          container.setAttribute('role', 'group');
          var heading = document.createElement('h3');
          heading.className = 'everlast-search-heading';
          heading.id = panel.id + '-' + group.type;
          heading.textContent = group.label;
          container.setAttribute('aria-labelledby', heading.id);
          container.appendChild(heading);
          panel.appendChild(container);
          group.items.forEach(function (item) {
            var meta = '';
            if (group.type === 'product') meta = productMeta(item);
            if (group.type === 'article' && !isNaN(Date.parse(item.published_at))) {
              meta = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
                year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC'
              }).format(new Date(item.published_at));
            }
            if (option(container, item.title, item.url, meta, group.type === 'product' ? item.image : null)) count += 1;
          });
          var more = option(container, 'View all ' + group.label.toLowerCase() + ' for “' + query + '”', searchUrl(query, group.type));
          if (more) more.classList.add('everlast-search-more');
        });
        if (!count) {
          var message = document.createElement('p');
          message.className = 'everlast-search-message';
          message.textContent = failed ? 'Suggestions are temporarily unavailable. Press Enter to search.' : 'No suggestions found. Try another term or view all results.';
          panel.appendChild(message);
        }
        var footer = document.createElement('div');
        footer.className = 'everlast-search-all';
        panel.appendChild(footer);
        var all = option(footer, 'View all results for “' + query + '”', searchUrl(query));
        if (all) all.classList.add('everlast-search-more');
        status.textContent = failed ? 'Suggestions unavailable. Press Enter to search.' : count + ' suggestions available. Use up and down arrow keys to explore.';
        show();
      }

      async function load(query, version) {
        var key = query.toLowerCase();
        if (cache.has(key)) {
          render(cache.get(key), query, false);
          return;
        }
        var controller = new AbortController();
        request = controller;
        var timeout = setTimeout(function () { controller.abort(); }, 8000);
        var params = new URLSearchParams({
          q: query, 'resources[type]': 'product,article,page',
          'resources[limit]': '10', 'resources[limit_scope]': 'each',
          'resources[options][fields]': 'title,tag'
        });
        try {
          var response = await fetch(root + 'search/suggest.json?' + params.toString(), { signal: controller.signal });
          if (!response.ok) throw new Error('Suggestions unavailable');
          var data = await response.json();
          var results = data.resources && data.resources.results;
          if (!results) throw new Error('Invalid suggestions');
          if (version !== generation) return;
          if (cache.size >= 20) cache.delete(cache.keys().next().value);
          cache.set(key, results);
          render(results, query, false);
        } catch (error) {
          if (version === generation) render({}, query, true);
        } finally {
          clearTimeout(timeout);
        }
      }

      function schedule() {
        close();
        var query = input.value.trim();
        if (composing || query.length < 2 || !normalize(query)) return;
        var version = generation;
        timer = setTimeout(function () {
          panel.replaceChildren();
          panel.setAttribute('aria-busy', 'true');
          var message = document.createElement('p');
          message.className = 'everlast-search-message';
          message.textContent = 'Searching…';
          panel.appendChild(message);
          status.textContent = 'Searching.';
          show();
          load(query, version);
        }, 200);
      }

      input.addEventListener('input', schedule);
      input.addEventListener('focus', schedule);
      input.addEventListener('compositionstart', function () { composing = true; close(); });
      input.addEventListener('compositionend', function () { composing = false; schedule(); });
      input.addEventListener('keydown', function (event) {
        if (event.isComposing) return;
        if (event.key === 'Escape') { close(); return; }
        if (panel.hidden) return;
        var options = Array.from(panel.querySelectorAll('[role="option"]'));
        if (!options.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          var previous = selected;
          if (previous >= 0) options[previous].setAttribute('aria-selected', 'false');
          selected = (selected + (event.key === 'ArrowDown' ? 1 : selected < 0 ? 0 : -1) + options.length) % options.length;
          options[selected].setAttribute('aria-selected', 'true');
          input.setAttribute('aria-activedescendant', options[selected].id);
          options[selected].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && selected >= 0) {
          event.preventDefault();
          options[selected].click();
        }
      });
      form.addEventListener('focusout', function () {
        setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 0);
      });
      form.addEventListener('submit', close);
      controllers.set(form, { close: close });
      if (document.activeElement === input) schedule();
    });
  }

  initialize(document);
  document.addEventListener('pointerdown', function (event) {
    controllers.forEach(function (controller, form) {
      if (!form.contains(event.target)) controller.close();
    });
  });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (controller, form) {
      if (event.target.contains(form)) { controller.close(); controllers.delete(form); }
    });
  });
})();
